import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectFailedPaymentsBannerDomain = (state) =>
  state.get('failedPaymentsBanner', initialState);

const makeSelectDefaultCard = () =>
  createSelector(selectFailedPaymentsBannerDomain, (substate) =>
    substate.get('defaultCard'),
  );

export { makeSelectDefaultCard };
